<tax-page-header titleText="registration.first.step.menu.name"></tax-page-header>

<div class="ui-kit-white-card">
  <tax-registration-top-menu></tax-registration-top-menu>
  <tax-eds-content
    [data]="certificateModalSignatureData"
    (signatureGenerated)="submitCertificate($event)"
  ></tax-eds-content>
</div>

<tax-success-window
  *ngIf="showSuccessWindow"
  [action]="'success-eds'"
  (closed)="proceedRegistration()"
></tax-success-window>
